import {
    GET_DATA_MANAGEMENT,
    GET_DATA_MANAGEMENT_SUCCESS,
    UPDATE_DATA_MANAGEMENT,
    UPDATE_DATA_MANAGEMENT_SUCCESS
} from './constants';

/**
 *
 * @returns {{type: string}}
 */
const getDataManagement = () => (
    {
        type: GET_DATA_MANAGEMENT
    }
);

/**
 *
 * @param result
 * @returns {{result: *, type: string}}
 */
const getDataManagementSuccess = (result) => ({
    type: GET_DATA_MANAGEMENT_SUCCESS,
    result,
});

/**
 *
 * @param formData
 * @returns {{formData: *, type: string}}
 */
const updateDataManagement = (formData) => ({
    type: UPDATE_DATA_MANAGEMENT,
    formData
});

/**
 *
 * @param result
 * @returns {{type: string, result: *}}
 */
const updateDataManagementSuccess = (result) => ({
    type: UPDATE_DATA_MANAGEMENT_SUCCESS,
    result
});

export {
    getDataManagement,
    getDataManagementSuccess,
    updateDataManagement,
    updateDataManagementSuccess
};